import { Navigate, useOutlet } from 'react-router-dom';

import { useContext, useEffect } from 'react';
import { UserContext } from '../../../context/UserProvider';
import { StyleContext } from '../../../context/StyleProvider';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';

const CustomerProtectedLayout = () => {
  const { token, userType } = useContext(UserContext);
  const { setMaxWidth } = useContext(StyleContext);
  const outlet = useOutlet();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!isMobile) {
      setMaxWidth(false);
    } else {
      setMaxWidth('sm');
    }
  }, [isMobile]);

  if (token === null || userType === null) {
    return <Navigate to="/" />;
  }

  return <>{outlet}</>;
};

export default CustomerProtectedLayout;
